<template>
  <div class="page-detail" v-loading="loading">
    <div class="content-header" style="margin-top: -10px;">
      <div class="line" v-if="$route.path !== '/reportDetail'"></div>
      <h3 class="title">
        {{serviceChart.channelname}}
        <div class="btnwrap" v-if="$route.path === '/reportDetail'">
          <el-button size="mini" @click="handleEdit"  v-if="userType.logintype == 'KEFU'">编辑报告建议与说明</el-button>
          <el-button size="mini" @click="handleCopy">复制分享链接</el-button>
          <el-button type="primary" size="mini" @click="handleDownload" :disabled="!serviceChart.excelurl?true:false">下载综合报表</el-button>
        </div>
      </h3>
      <div class="date">
        <span>服务数据范围：{{serviceChart.servicescope || reportQuery.begintime + '~' +reportQuery.endtime|| '--'}}</span>
        <span v-if="$route.path === '/reportDetail'">生成客服：{{serviceChart.username || '--'}}</span>
        <span v-if="!serviceChart.createtime">报告生成时间：--</span>
        <span v-else>报告生成时间：{{serviceChart.createtime | yearMonthDayTime}}</span>
      </div>
    </div>
    <el-row :gutter="20" type="flex" justify="space-between">
      <el-col :span="12" v-show="stateCInventoryData.platformMap&&CInventoryData[0].total>0">
        <panelTitle title="渠道信息盘点" />
        <div class="content-panel">
          <p class="explain">
            {{`在本段服务时间内，经过我们的摸排、整理与收集，共整理收录 ${CInventoryData[0].total} 家线上销售的店铺档案信息，其中授权店铺 ${CInventoryData[0].authCount} 家，灰名单店铺 ${CInventoryData[0].greyCount} 家，
            黑名单店铺 ${CInventoryData[0].blackCount} 家。我们同时盘点到 ${CInventoryData[0].dealerCount}家店铺背后的实体经销商信息。其中收录的 ${CInventoryData[0].total} 家店铺所属平台情况如下：`}}
          </p>
          <vueEchart id="chart1" />
          <div class="explainText" v-if="isEdit || serviceStep.step === 1">
            <p class="title">建议与说明</p>
            <el-input type="textarea" :rows="3" v-model="reportForm.dealerandshopadvice"></el-input>
          </div>
          <div class="explainText" v-else-if="serviceChart.dealerandshopadvice">
            <p class="title">建议与说明</p>
            <p class="textarea">{{serviceChart.dealerandshopadvice}}</p>
          </div>
        </div>
      </el-col>
      <el-col
        :span="12"
        v-show="serviceLowpriceList.content.length>0 || (stateServiceLowpriceChart&&stateServiceLowpriceChart.length>0)"
      >
        <panelTitle title="日常违规检索" />
        <div class="content-panel">
          <el-row>
            <el-col :span="24">
              <p
                class="explain"
              >{{`在本段服务时间内，我们共进行了${serviceLowpriceCount.searchCount || 0}次违规商品链接的检索，共计检索出违规商品链接${serviceLowpriceCount.totalCount || 0}条。每次检索时间、违规数量及各平台的违规情况如下：`}}</p>
            </el-col>
            <el-col
              v-show="serviceLowpriceList.content.length>0"
              :span="stateServiceLowpriceChart&&stateServiceLowpriceChart.length > 0 ? 11 : 24"
              style="padding: 0 15px;"
            >
              <div class="table-wrap">
                <el-table :data="serviceLowpriceList.content" height="272" style="width: 100%">
                  <el-table-column label="序号" width="30" type="index"></el-table-column>
                  <el-table-column label="检索时间" align="center" prop="syncdate"></el-table-column>
                  <el-table-column label="违规商品数" align="center" prop="totalcount"></el-table-column>
                  <el-table-column type="expand" width="20">
                    <template slot-scope="scope">
                      <el-row :gutter="20">
                        <el-col :span="12">淘宝天猫：{{scope.row.tbtm || '--'}}</el-col>
                        <el-col :span="12">拼多多：{{scope.row.pdd || '--'}}</el-col>
                        <el-col :span="12">京东商城：{{scope.row.jd || '--'}}</el-col>
                        <el-col :span="12">苏宁易购：{{scope.row.sn || '--'}}</el-col>
                      </el-row>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  small
                  layout="total,prev, pager, next"
                  :total="serviceLowpriceList.totalElements"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :page-size="Number(5)"
                ></el-pagination>
              </div>
            </el-col>
            <el-col
              :span="serviceLowpriceList.content.length>0 ? 13 : 24"
              v-show="stateServiceLowpriceChart&&stateServiceLowpriceChart.length"
            >
              <p
                class="explain"
              >{{`其中累计违规商品链接最多的平台是${serviceLowpriceCount.maxPlateform || '--'}，共计检索出违规${serviceLowpriceCount.maxCount || 0}条，各平台的违规商品链接及授权情况如下:`}}</p>
              <vueEchart id="chart2" />
            </el-col>
          </el-row>
          <div class="explainText" v-if="isEdit || serviceStep.step === 1">
            <p class="title">建议与说明</p>
            <el-input type="textarea" :rows="3" v-model="reportForm.everydaylowpriceadvice"></el-input>
          </div>
          <div class="explainText" v-else-if="serviceChart.everydaylowpriceadvice">
            <p class="title">建议与说明</p>
            <p class="textarea">{{serviceChart.everydaylowpriceadvice}}</p>
          </div>
        </div>
      </el-col>
      <el-col :span="12" v-if="stateInformreport">
        <panelTitle title="违规通知复查" />
        <div class="content-panel">
          <p class="explain">
            {{`在本段服务时间内，我们共计通知整改违规链接 ${informreport.top.cas1 || 0}条。其中通知整改后经复查合格的商品链接${informreport.top.cas2 || 0}条数
            ，复查不合格的商品链接数量${informreport.top.cas3 || 0}条，通知整改合理率约${informreport.top.cas4 || 0}。其中各平台通知整改数量及复查情况如下：`}}
          </p>
          <vueEchart id="chart3" />
          <div class="explainText" v-if="isEdit || serviceStep.step === 1">
            <p class="title">建议与说明</p>
            <el-input type="textarea" :rows="3" v-model="reportForm.informreportadvice"></el-input>
          </div>
          <div class="explainText" v-else-if="serviceChart.informreportadvice">
            <p class="title">建议与说明</p>
            <p class="textarea">{{serviceChart.informreportadvice}}</p>
          </div>
        </div>
      </el-col>
      <el-col :span="12" v-if="stateIPRCompliantData&&stateIPRCompliantData.maincount>0">
        <panelTitle title="知识产权投诉" />
        <div class="content-panel">
          <p
            class="explain"
          >{{`在本段服务时间内，我们通过知识产权途径投诉侵权链接${stateIPRCompliantData.maincount} 条，其中阿里知识产权投诉 ${stateIPRCompliantData.tbcount} 条，京东知识产权投诉 ${stateIPRCompliantData.jdcount} 条，苏宁知识产权投诉${stateIPRCompliantData.sncount} 条，拼多多知识产权投诉 ${stateIPRCompliantData.pddcount} 条。`}}</p>
          <vueEchart id="chart4" />
          <div class="explainText" v-if="isEdit || serviceStep.step === 1">
            <p class="title">建议与说明</p>
            <el-input type="textarea" :rows="3" v-model="reportForm.intellectualadvice"></el-input>
          </div>
          <div class="explainText" v-else-if="serviceChart.intellectualadvice">
            <p class="title">建议与说明</p>
            <p class="textarea">{{serviceChart.intellectualadvice}}</p>
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="footBtn" v-if="serviceStep.step === 1 ">
      <el-button size="small" class="confirm" @click="stepNext">下一步</el-button>
      <el-button size="small" class="cancel" @click="stepBack">返回</el-button>
    </div>
    <div class="footBtn" v-else-if="$route.path === '/reportDetail' && isEdit ">
      <el-button size="small" class="confirm" @click="confirmEdit">确定</el-button>
      <el-button size="small" class="cancel" @click="isEdit = false">取消</el-button>
    </div>
  </div>
</template>
<script>
import panelTitle from "@/components/panelTitle";
import vueEchart from "./echart";
import { barOptionConfig } from "@/libs/echartOption/barOption.js";
import { pieOptionConfig } from "@/libs/echartOption/pieOption.js";
import { fetchPost } from "@/libs/reqCommon";
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  components: { panelTitle, vueEchart },
  data() {
    return {
      echartBarLowPrice: null,
      query: {
        pageSize: 5,
        pageNo: 1
      },
      userType: '',
      isEdit: false,
      reportForm: {},
	  loading: true,
    };
  },
  methods: {
    ...mapActions(["reqServiceLowpriceList", "reqServiceChart"]),
    getParams() {
      let query = this.query;
      if (this.$route.query.id) {
        query = {
          ...query,
          ...this.$route.query
        };
      } else {
        query = {
          ...query,
          ...this.reportQuery,
          startTime: this.reportQuery.begintime,
          endTime: this.reportQuery.endtime
        };
      }
      return query;
    },
    handleSizeChange(pageSize) {
      this.query.pageSize = pageSize;
      let query = this.getParams();
      this.reqServiceLowpriceList(query);
    },
    handleCurrentChange(pageNo) {
      this.query.pageNo = pageNo;
      let query = this.getParams();
      this.reqServiceLowpriceList(query);
    },
    handleCopy() {
      let oInput = document.createElement("input");
      oInput.value = this.$route.query.url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: "复制成功",
        type: "success"
      });
      oInput.remove();
    },
    handleDownload() {
		console.log(this.serviceChart)
      let url = this.serviceChart.excelurl;
      window.open(url);
    },
    handleEdit() {
      this.isEdit = true;
      let {
        dealerandshopadvice,
        informreportadvice,
        intellectualadvice,
        everydaylowpriceadvice
      } = this.serviceChart;
      this.reportForm = {
        dealerandshopadvice,
        informreportadvice,
        intellectualadvice,
        everydaylowpriceadvice
      };
    },
    // 编辑建议确定
    confirmEdit() {
      let url = "/hcm/hcmChannelServiceReport/uodateadvice";
      let query = {
        ...this.reportForm,
        id: this.$route.query.id
      };
      fetchPost(url, query).then(res => {
        if (res.status == "10000") {
          this.$message({
            message: "操作成功！",
            type: res.message
          });
          this.reqServiceChart({ id: this.$route.query.id });
          this.isEdit = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    stepNext() {
      this.$store.commit("changeStep", {
        stepText: "第三步",
        step: 2
      });
      let query = {
        ...this.reportQuery,
        ...this.reportForm
      };
      this.$store.commit("createQuery", query);
    },
    stepBack() {
      this.$store.commit("changeStep", {
        stepText: "第一步",
        step: 0
      });
    }
  },
  async mounted() {
    this.userType = JSON.parse(window.localStorage.userData);
    console.log(this.userType.logintype)
    let query = this.getParams();
    await this.reqServiceLowpriceList(query);
    this.loading = false;
  },
  computed: {
    ...mapState({
      serviceStep: state => state.serviceReport.serviceStep,
      reportQuery: state => state.serviceReport.reportQuery,
      serviceLowpriceList: state => state.serviceReport.serviceLowpriceList,
      serviceLowpriceCount: state => state.serviceReport.serviceLowpriceCount,
      serviceChart: state => state.serviceReport.serviceChart,

      stateCInventoryData: state => state.serviceReport.CInventoryData,
      stateIPRCompliantData: state => state.serviceReport.IPRCompliantData,
      stateInformreport: state => state.serviceReport.informreport,
      stateServiceLowpriceChart: state =>
        state.serviceReport.serviceLowpriceChart
    }),
    ...mapGetters([
      "serviceLowpriceChartData",
      "CInventoryData",
      "informreport"
    ])
  }
};
</script>
<style lang="scss">
// .el-card__body {
//   padding: 0px !important;
// }
// .el-card {
//   background-color: #F3F4F5 !important;
// }
.content-header {
  .line {
    // height: 1px;
    background: #eee;
  }
  .title {
    line-height: 0;
    .btnwrap {
      float: right;
    }
  }
  .date {
    span {
      margin-right: 50px;
    }
  }
}
.content-panel {
  height: calc(100% - 75px);
  background-color: #ffffff;
  box-shadow: 0px 3px 8px 1px rgba(57, 57, 57, 0.11);
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  padding: 15px;
  .explain {
    margin: 0;
    text-indent: 20px;
  }
  .chart-wrap {
    margin: 0 auto;
  }
  .table-wrap {
    height: 298px;
    padding: 1px;
    border-radius: 6px;
    border: solid 1px #d9d9d9;
    box-sizing: border-box;
    .el-table {
      border-bottom: 1px solid #eee;
      .cell {
        padding: 0 !important;
        line-height: normal;
      }
      td,
      th {
        padding: 5px 0px 5px 2px !important;
      }
      &__expand-icon {
        font-size: 16px;
        color: #3aa0ff;
        & > .el-icon {
          margin-top: -8px !important;
        }
      }
    }
  }

  .el-pagination {
    text-align: right;
    padding: 0;
  }

  .explainText {
    .title {
      font-weight: 600;
    }
    padding: 0 20px;
    box-sizing: border-box;
    width: 100%;
    height: 110px;
  }
}
.footBtn {
  margin-top: 20px;
  text-align: center;
}

.el-row--flex {
  flex-wrap: wrap;
}
</style>
